import React, { FC, useContext } from 'react';
import logoUrl from 'app/assets/logo/Website_Logo.svg';
import { Link } from 'react-router-dom';
import { SearchContext } from 'app/contexts/SearchContext';
import { sanitizedContent } from 'app/utils/sanitizedContent';
import './Footer.scss';
import uniqid from 'uniqid';

const Footer: FC = () => {
  const { footerLinks, disclaimer, socialLinks } = useContext(SearchContext);

  const containerText = (
    <>
      {disclaimer?.length ? (
        <div
          dangerouslySetInnerHTML={sanitizedContent(disclaimer[0].description)}
        />
      ) : null}
    </>
  );

  const socialUrlsRender = socialLinks?.map(
    ({ link, icon, icon_alt }, index) => (
      <a href={link} target="_blank" rel="noreferrer" key={uniqid()}>
        <img src={icon} alt={icon_alt} className="footer__social-link" />
      </a>
    ),
  );

  const pageUrlsRender = footerLinks?.map(
    ({ name, internal_page, internal_insight, external_url }, index) => {
      return (
        <>
          {internal_page || internal_insight ? (
            <Link
              to={
                internal_page
                  ? `/${internal_page.slug}`
                  : internal_insight
                  ? `/insights/${internal_insight.page_url}`
                  : ''
              }
              key={uniqid()}
              className="footer__page-link"
            >
              {name}
            </Link>
          ) : external_url ? (
            <a
              href={external_url}
              key={uniqid()}
              target="_blank"
              rel="noreferrer"
              className="footer__page-link"
            >
              {name}
            </a>
          ) : null}
        </>
      );
    },
  );

  return (
    <footer className="footer">
      <Link to={'/'}>
        <div className="footer__logo-wrapper">
          <img className={'footer__logo'} src={logoUrl} alt="footer-logo" />
        </div>
      </Link>
      <div className="footer__page-links">{pageUrlsRender}</div>
      <div className="footer__social-links">{socialUrlsRender}</div>
      <div className="footer__container">{containerText}</div>
    </footer>
  );
};

export default Footer;
